import React from 'react';
import { Spinner } from 'reactstrap';

const Loader = ({ size, className = '' }) => (
  <div className="text-center">
    <Spinner className={className} color="primary" size={size} />
  </div>
);
export default Loader;
